import { render, staticRenderFns } from "./BaSwapBidWantedModal.vue?vue&type=template&id=02847b80&scoped=true&"
import script from "./BaSwapBidWantedModal.vue?vue&type=script&lang=js&"
export * from "./BaSwapBidWantedModal.vue?vue&type=script&lang=js&"
import style0 from "./BaSwapBidWantedModal.vue?vue&type=style&index=0&id=02847b80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02847b80",
  null
  
)

export default component.exports